import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Adjustment',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Adjustment',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Adjustment',
    column_type: 'datetime',
  },
  adjustable_type: {
    model_name: 'Adjustment',
    column_type: 'string',
  },
  amount: {
    model_name: 'Adjustment',
    column_type: 'decimal',
  },
  adjustable: {
    model_name: 'Adjustment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'adjustable',
      model_name: '',
    },
  },
  adjustable_id: {
    model_name: 'Adjustment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'adjustable',
      model_name: '',
    },
  },
  creator: {
    model_name: 'Adjustment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  creator_id: {
    model_name: 'Adjustment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  remark: {
    model_name: 'Adjustment',
    column_type: 'text',
  },
  can_update: {
    model_name: 'Adjustment',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'Adjustment',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
